import {
  UPDATE_COMPANY_REQUEST,
  UPDATE_COMPANY_ERROR,
  UPDATE_COMPANY_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/updateEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default (entity, entityTableData) => (state = initialState, action) => {

  context.init(context);

  context.UPDATE_ENTITY_REQUEST = UPDATE_COMPANY_REQUEST;
  context.UPDATE_ENTITY_ERROR = UPDATE_COMPANY_ERROR;
  context.UPDATE_ENTITY_SUCCESS = UPDATE_COMPANY_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "company";
  context.entityLocation = RESOURCES.Companies;

  return context.execute(context)(entity, entityTableData)(state, action);
};